// Експорт тікету в .zip архів:
//   ticket-<id>.md  - опис тікету, посилання на чат та список вкладень
//   chat-<id>.md    - переписка чату (за наявності)
//   images/         - зображення з опису та чату
//   files/          - вкладення тікету (логи та інші матеріали), пронумеровані в порядку додавання

import JSZip from "jszip";
import { buildMainMarkdown, buildChatMarkdown } from "./markdownSections";
import { prepareAttachments } from "./attachments";
import { addAttachmentsToZip, addImagesToZip, downloadBlob } from "./zip";

// ticket      - дані тікету (ticketId, ticketName, createComment/reason, ...)
// messages    - повідомлення чату (необов'язково)
// attachments - вкладення тікету: [{ name, type, datetime, data (ArrayBuffer/Blob) }]
async function exportTicketToMd(ticket, messages, attachments){
    let images = []; // наповнюється під час побудови markdown (опис + чат)
    let hasChat = Array.isArray(messages) && messages.some(m => !m.deleted);
    let chatFilename = `chat-${ticket.ticketId}.md`;
    let preparedFiles = prepareAttachments(attachments);

    // головний документ (наповнює images зображеннями з опису)
    let mainMd = buildMainMarkdown(ticket, {
        images,
        hasChat,
        chatFilename,
        attachments: preparedFiles
    });

    let zip = new JSZip();
    zip.file(`ticket-${ticket.ticketId}.md`, mainMd);

    // переписка чату (наповнює images зображеннями з повідомлень)
    if(hasChat){
        zip.file(chatFilename, buildChatMarkdown(ticket, messages, images));
    }

    addAttachmentsToZip(zip, preparedFiles);
    await addImagesToZip(zip, images);

    let zipBlob = await zip.generateAsync({ type: "blob" });
    downloadBlob(zipBlob, `ticket-${ticket.ticketId}.zip`);
}

export { exportTicketToMd };
